import { castQueueSetRepeatMode } from "../castRequests/media/queueSetRepeatMode";
import { convertToRepeatMode } from "../helpers";
import { store } from "global";

export function playerRepeat() {
    const repeatMode = convertToRepeatMode(store.getState().player.repeat);
    return castQueueSetRepeatMode(repeatMode);
}
